/* Модуль прямого эфира, ссылок на чаты и страниц уроков */
function getChannelUrl() {
  try {
    const raw = localStorage.getItem('meta_marathon_settings');
    if (raw) {
      const s = JSON.parse(raw);
      if (s.channel_url) return s.channel_url;
    }
    const directUrl = localStorage.getItem('meta_channel_url') || window.META_CHANNEL_URL;
    if (directUrl) return directUrl;
  } catch (e) {}
  return 'https://t.me/+07ykiT7thlFkOGQy';
}

function isChannelSubscribed() {
  // На вечнозеленом веб-сайте подписка на Telegram добровольна и не блокирует доступ к урокам
  return true;
}

function handleChannelGateOpenLink(e, url) {
  if (e && e.preventDefault) e.preventDefault();
  triggerHaptic('light');
  const targetUrl = url || getChannelUrl();
  if (window.Telegram?.WebApp && typeof window.Telegram.WebApp.openTelegramLink === 'function') {
    window.Telegram.WebApp.openTelegramLink(targetUrl);
  } else {
    window.open(targetUrl, '_blank');
  }
}

let channelGatePollInterval = null;

function unlockChannelGate() {
  if (channelGatePollInterval) {
    clearInterval(channelGatePollInterval);
    channelGatePollInterval = null;
  }
  localStorage.setItem('meta_channel_subscribed', 'true');
  localStorage.setItem('meta_unlocked_days', JSON.stringify([1, 2, 3, 4]));
  const gateCard = document.getElementById('channelGateCard') || document.getElementById('day1ChannelGateCard');
  if (gateCard) gateCard.style.display = 'none';

  const u = typeof getUser === 'function' ? getUser() : null;
  if (u) {
    u.channel_subscribed = true;
    u.unlocked_days = [1, 2, 3, 4];
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(u)); } catch (e) {}
  }

  triggerHaptic('success');
  if (typeof showToast === 'function') {
    showToast('✓ Доступ открыт! Все 4 урока разблокированы.');
  }
  if (typeof trackGoal === 'function') {
    trackGoal('channel_subscribed', { source: 'channel_gate' });
  }
  if (typeof updateDayPageUI === 'function') {
    updateDayPageUI();
  }
  if (typeof updateLandingProgramUI === 'function') {
    updateLandingProgramUI();
  }
}

function unlockDay1ChannelGate() {
  unlockChannelGate();
}

function startChannelGatePolling() {
  if (channelGatePollInterval) return;
  let attempts = 0;
  channelGatePollInterval = setInterval(async () => {
    attempts++;
    if (attempts > 50) {
      clearInterval(channelGatePollInterval);
      channelGatePollInterval = null;
      return;
    }
    const u = typeof getUser === 'function' ? getUser() : null;
    const tgId = u?.telegram_id || u?.telegramId || localStorage.getItem('meta_tg_user_id') || '';
    const userId = u?.id || '';
    if (!userId && !tgId) return;

    try {
      const res = await fetch('/api/user/channel-subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ telegram_id: tgId, user_id: userId })
      });
      const data = await res.json();
      if (data.ok && data.subscribed) {
        unlockChannelGate();
      }
    } catch (e) {}
  }, 2500);
}

// Проверка параметров URL на открытие урока при возвращении из Telegram
(function checkChannelSubParam() {
  try {
    const p = new URLSearchParams(window.location.search);
    if (p.get('channel_sub') === '1' || p.get('subscribed') === '1') {
      localStorage.setItem('meta_channel_subscribed', 'true');
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          unlockChannelGate();
        });
      } else {
        unlockChannelGate();
      }
    }
    window.addEventListener('focus', () => {
      const gateCard = document.getElementById('channelGateCard') || document.getElementById('day1ChannelGateCard');
      if (gateCard && gateCard.style.display !== 'none' && typeof isRegistered === 'function' && isRegistered()) {
        confirmChannelSubscription(true);
      }
    });
  } catch (e) {}
})();

async function confirmChannelSubscription(isSilent = false) {
  if (typeof isRegistered === 'function' && !isRegistered()) {
    if (typeof openModal === 'function') {
      openModal(window.location.pathname + (window.location.search || ''));
    }
    return;
  }

  if (!isSilent) triggerHaptic('medium');
  const confirmBtn = document.getElementById('channelGateConfirmBtn');
  const gateFeedback = document.getElementById('channelGateFeedback');
  if (confirmBtn && !isSilent) {
    confirmBtn.disabled = true;
    confirmBtn.innerHTML = '<span>⏳ Проверяем заявку...</span>';
  }
  if (gateFeedback && !isSilent) {
    gateFeedback.style.display = 'none';
  }

  const u = typeof getUser === 'function' ? getUser() : null;
  const tgId = u?.telegram_id || u?.telegramId || localStorage.getItem('meta_tg_user_id') || '';
  const userId = u?.id || '';

  try {
    const res = await fetch('/api/user/channel-subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ telegram_id: tgId, user_id: userId })
    });
    const data = await res.json();

    if (data.ok && data.subscribed) {
      unlockChannelGate();
      return;
    }

    if (data.status === 'need_bot_verify' && data.bot_url) {
      startChannelGatePolling();
      if (confirmBtn) {
        confirmBtn.disabled = false;
        confirmBtn.innerHTML = '<span>🤖 Подтвердить через Telegram-бота</span>';
        confirmBtn.onclick = () => {
          if (window.Telegram?.WebApp && typeof window.Telegram.WebApp.openTelegramLink === 'function') {
            window.Telegram.WebApp.openTelegramLink(data.bot_url);
          } else {
            window.open(data.bot_url, '_blank');
          }
        };
      }
      if (gateFeedback) {
        gateFeedback.innerHTML = `
          <div style="background: rgba(212, 175, 110, 0.15); border: 1px solid #D4AF6E; border-radius: 12px; padding: 10px; margin-top: 12px; font-size: 12px; color: #260C14; line-height: 1.4;">
            ℹ️ Чтобы подтвердить подписку с ПК, нажмите кнопку <b>«Подтвердить через Telegram-бота»</b> выше - бот свяжет ваш аккаунт и моментально откроет уроки.
          </div>
        `;
        gateFeedback.style.display = 'block';
      }
      return;
    }

    if (confirmBtn) {
      confirmBtn.disabled = false;
      confirmBtn.innerHTML = '<span>🔄 Я уже в канале - открыть урок</span>';
    }
    if (gateFeedback && !isSilent) {
      gateFeedback.innerHTML = `
        <div style="background: rgba(220, 53, 69, 0.10); border: 1px solid rgba(220, 53, 69, 0.35); border-radius: 12px; padding: 10px; margin-top: 12px; font-size: 12px; color: #DC3545; line-height: 1.4;">
          ❌ ${data.message || 'Заявка в закрытый канал еще не найдена. Пожалуйста, перейдите в закрытый канал по кнопке выше, подайте заявку и нажмите проверку повторно.'}
        </div>
      `;
      gateFeedback.style.display = 'block';
    }
    if (!isSilent) triggerHaptic('error');
  } catch (e) {
    if (confirmBtn) {
      confirmBtn.disabled = false;
      confirmBtn.innerHTML = '<span>🔄 Я уже в канале - открыть урок</span>';
    }
    if (gateFeedback && !isSilent) {
      gateFeedback.innerHTML = `
        <div style="background: rgba(220, 53, 69, 0.10); border: 1px solid rgba(220, 53, 69, 0.35); border-radius: 12px; padding: 10px; margin-top: 12px; font-size: 12px; color: #DC3545; line-height: 1.4;">
          ⚠️ Произошла ошибка связи с сервером. Пожалуйста, повторите попытку через несколько секунд.
        </div>
      `;
      gateFeedback.style.display = 'block';
    }
  }
}

function renderChannelGate(targetEl, currentDayNum) {
  // На веб-сайте принудительный гейт канала полностью отключен
  const gateCard = document.getElementById('channelGateCard') || document.getElementById('day1ChannelGateCard');
  if (gateCard) gateCard.style.display = 'none';
}

function renderDay1ChannelGate(targetEl) {
  renderChannelGate(targetEl, 1);
}

window.isChannelSubscribed = isChannelSubscribed;
window.confirmChannelSubscription = confirmChannelSubscription;
window.handleChannelGateOpenLink = handleChannelGateOpenLink;
window.unlockChannelGate = unlockChannelGate;
window.unlockDay1ChannelGate = unlockDay1ChannelGate;
window.renderChannelGate = renderChannelGate;
window.renderDay1ChannelGate = renderDay1ChannelGate;
window.updateDayPageUI = updateDayPageUI;

  // Обновление интерфейса страниц уроков (День 1, 2, 3, 4)
  function updateDayPageUI(optionalPath) {
    const path = optionalPath || window.location.pathname;
    let currentDay = null;
    if (path.includes('day-1')) currentDay = 1;
    if (path.includes('day-2')) currentDay = 2;
    if (path.includes('day-3')) currentDay = 3;
    if (path.includes('day-4')) currentDay = 4;

    if (!currentDay) return;

    const currentDayNum = parseInt(currentDay, 10) || 1;
    const badge = document.querySelector('.nav-top-row .badge-locked, .nav-top-row .badge-available, #dayStatusBadge');
    const completeBlock = document.getElementById('completeBlock');
    const info = MARATHON_DAYS_INFO[currentDay];
    const videoUrl = getVideoUrlForDay(currentDayNum);

    const inlineVideoCard = document.getElementById(`day${currentDayNum}VideoCard`) || document.querySelector('.inline-video-card');
    let broadcastCard = document.getElementById(`day${currentDayNum}BroadcastCard`) || document.querySelector('.broadcast-card:not(.inline-video-card)');
    const gateCard = document.getElementById('channelGateCard') || document.getElementById('day1ChannelGateCard');

    // 1. Для дней 2, 3, 4: если пользователь не зарегистрирован - скрываем видео и открываем регистрацию.
    // Для ДНЯ 1: урок открыт сразу, плеер не скрывается!
    if (currentDayNum > 1 && typeof isRegistered === 'function' && !isRegistered()) {
      if (inlineVideoCard) inlineVideoCard.style.display = 'none';
      if (broadcastCard) broadcastCard.style.display = 'none';
      if (completeBlock) completeBlock.style.display = 'none';
      if (gateCard) gateCard.style.display = 'none';
      const materialsCard = document.querySelector('.lesson-materials-card');
      if (materialsCard) materialsCard.style.display = 'none';
      if (typeof openModal === 'function') {
        openModal(window.location.pathname);
      } else if (typeof window.openModal === 'function') {
        window.openModal(window.location.pathname);
      }
      return;
    }

    // 2. Заглушка канала скрыта — доступ к урокам прямой
    if (gateCard) {
      gateCard.style.display = 'none';
    }

    const unlocked = isDayUnlocked(currentDay);

    // Управление статическими блоками дня, если они есть в верстке
    const dayUnlockedBlock = document.getElementById(`day${currentDayNum}UnlockedBlock`);
    const dayLockedBlock = document.getElementById(`day${currentDayNum}LockedBlock`);
    if (dayUnlockedBlock && dayLockedBlock) {
      dayUnlockedBlock.style.display = unlocked ? 'block' : 'none';
      dayLockedBlock.style.display = unlocked ? 'none' : 'block';
    }

    const materialsCard = document.querySelector('.lesson-materials-card');
    if (materialsCard) {
      materialsCard.style.display = unlocked ? 'block' : 'none';
    }

    if (unlocked) {
      // День открыт!
      if (typeof trackGoal === 'function') {
        const viewKey = `meta_view_day_${currentDayNum}`;
        if (!sessionStorage.getItem(viewKey)) {
          sessionStorage.setItem(viewKey, 'true');
          trackGoal(`day${currentDayNum}_view`, { day: currentDayNum });
        }
      }

      if (badge) {
        badge.className = 'badge-available';
        badge.textContent = '✓ Доступно';
      }

      // 1. Если для этого дня есть видеозапись (videoUrl)
      if (videoUrl) {
        const isDirect = /\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(videoUrl) || /fileservice\/file\/download\//i.test(videoUrl);
        if (inlineVideoCard) {
          inlineVideoCard.style.display = 'block';
          const vid = inlineVideoCard.querySelector('video');
          const wrapper = inlineVideoCard.querySelector('.inline-video-wrapper') || document.getElementById(`day${currentDayNum}VideoWrapper`);
          if (isDirect) {
            if (vid && (!vid.src || vid.src === '' || vid.src === window.location.href)) {
              vid.src = videoUrl;
            } else if (!vid && wrapper) {
              wrapper.innerHTML = `
                <video 
                  id="day${currentDayNum}InlineVideo"
                  src="${videoUrl}" 
                  controls 
                  playsinline 
                  preload="metadata"
                  controlsList="nodownload noplaybackrate"
                  oncontextmenu="return false;"
                ></video>
              `;
            }
          } else if (wrapper) {
            wrapper.innerHTML = `<iframe src="${videoUrl}" allow="autoplay; fullscreen; picture-in-picture; encrypted-media" allowfullscreen style="width: 100%; height: 100%; border: none;"></iframe>`;
          }
          if (broadcastCard) {
            broadcastCard.style.display = 'none';
          }
        } 
        // 2. Если на странице остался только broadcastCard (из кэша) и для этого дня есть запись
        else if (broadcastCard) {
          broadcastCard.className = 'card inline-video-card';
          broadcastCard.id = `day${currentDayNum}VideoCard`;
          broadcastCard.innerHTML = `
            <div class="inline-video-header">
              <div class="inline-video-title">
                <span>🎬</span> <span>Урок • День ${currentDayNum}</span>
              </div>
              <button type="button" class="inline-video-fullscreen-btn" onclick="toggleInlineVideoFullscreen('day${currentDayNum}VideoWrapper', 'day${currentDayNum}InlineVideo')">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/></svg>
                <span>На весь экран</span>
              </button>
            </div>
            <div class="inline-video-wrapper" id="day${currentDayNum}VideoWrapper">
              ${isDirect ? `
                <video 
                  id="day${currentDayNum}InlineVideo"
                  src="${videoUrl}" 
                  controls 
                  playsinline 
                  preload="metadata"
                  controlsList="nodownload noplaybackrate"
                  oncontextmenu="return false;"
                ></video>
              ` : `
                <iframe src="${videoUrl}" allow="autoplay; fullscreen; picture-in-picture; encrypted-media" allowfullscreen style="width: 100%; height: 100%; border: none;"></iframe>
              `}
            </div>

          `;
        }
      } else {
        // Записи еще нет: прячем видеокарточку и показываем карточку эфира
        if (inlineVideoCard) {
          inlineVideoCard.style.display = 'none';
        }
        if (broadcastCard) {
          broadcastCard.style.display = 'block';
        }

        // 3. Если записи еще нет, но день открыт (предстоящий живой эфир), и статических блоков не было
        if (broadcastCard && !dayUnlockedBlock) {
        const channelUrl = getChannelUrl();
        broadcastCard.innerHTML = `
          <div style="background: rgba(34, 169, 107, 0.12); border: 1.5px solid rgba(34, 169, 107, 0.35); border-radius: 14px; padding: 14px; margin-bottom: 12px; text-align: center;">
            <div style="font-size: 15px; font-weight: 800; color: #1A8754; margin-bottom: 4px;">
              🟢 День ${currentDayNum} разблокирован!
            </div>
            <div style="font-size: 12.5px; color: #5C5857; line-height: 1.45;">
              Материалы урока доступны для просмотра прямо сейчас.
            </div>
          </div>

          <div style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 8px;">
            <button type="button" class="btn-emerald" id="liveBroadcastBtn" onclick="MetaOnboarding.openLiveBroadcast(${currentDayNum})" style="width: 100%;">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>
              <span>▶️ Смотреть видеоурок</span>
              <span>→</span>
            </button>
          </div>

          ${channelUrl ? `
          <div style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 8px;">
            <a href="${channelUrl}" target="_blank" rel="noopener noreferrer" class="btn-tg-channel" style="display: flex; align-items: center; justify-content: center; gap: 8px; width: 100%; height: 44px; background: #FFFFFF; border: 1px solid rgba(26, 135, 84, 0.3); border-radius: 12px; color: #1A8754; font-size: 13px; font-weight: 700; text-decoration: none; box-sizing: border-box; margin-bottom: 0;">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0;"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
              <span>Вступить в закрытый Telegram-канал</span>
            </a>
          </div>` : ''}
        `;
      }
    }

    if (completeBlock) {
        completeBlock.style.display = 'block';
      }
    } else {
      // День закрыт: карточка ожидания с таймером
      if (badge) {
        badge.className = 'badge-locked';
        badge.textContent = '🔒 Доступ закрыт';
      }
      if (inlineVideoCard) {
        inlineVideoCard.style.display = 'none';
      }
      let lockTarget = broadcastCard || inlineVideoCard;
      if (lockTarget) {
        const prevDay = currentDayNum - 1;
        const u = (typeof getUser === 'function' ? getUser() : {}) || {};
        const prevCompleted = localStorage.getItem(`meta_day_${prevDay}_completed`) === 'true' ||
          Boolean(u.completed_days && u.completed_days[prevDay]);

        let slotLabel = 'завтра в 10:00 МСК';
        if (prevCompleted) {
          let completedAt = localStorage.getItem(`meta_day_${prevDay}_completed_at`) ||
            (u.completed_days && u.completed_days[prevDay]);
          if (typeof window.getDripSlotLabel === 'function') {
            slotLabel = window.getDripSlotLabel(completedAt);
          }
        }

        lockTarget.style.display = 'block';
        lockTarget.className = 'card broadcast-card';
        lockTarget.innerHTML = `
          <div class="broadcast-timing">
            ⏳ Урок ${currentDay}
          </div>

          <p style="font-size: 13px; color: var(--text-muted); margin-bottom: 12px; text-align: center; line-height: 1.4;">
            ${prevCompleted 
              ? `Урок ${currentDay} откроется ${slotLabel}:` 
              : `Урок откроется автоматически по таймеру (бесплатно):`}
          </p>

          <div style="background: rgba(26, 135, 84, 0.08); border: 1px solid rgba(26, 135, 84, 0.2); border-radius: 12px; padding: 14px; text-align: center; margin-bottom: 10px;">
            <div style="font-size: 18px; font-weight: 700; color: #1A8754;" id="day${currentDay}LiveLockTimer">⏳ Откроется ${slotLabel}</div>
            <div style="font-size: 11px; color: var(--text-muted); margin-top: 4px;">Доступ предоставляется бесплатно</div>
          </div>
        `;
      }
      if (completeBlock) {
        completeBlock.style.display = 'none';
      }
    }

    if (typeof startDripCountdowns === 'function') {
      startDripCountdowns();
    }

    // Проверяем, отмечен ли этот день просмотренным
    if (localStorage.getItem(`meta_day_${currentDay}_completed`) === 'true') {
      const btn = document.getElementById('markCompletedBtn');
      const compBadge = document.getElementById('completedBadge');
      if (btn && compBadge) {
        btn.style.display = 'none';
        compBadge.style.display = 'block';
      }
    }
  }

  function toggleInlineVideoFullscreen(wrapperId, videoId) {
    const wrapper = document.getElementById(wrapperId);
    const video = document.getElementById(videoId);
    if (!wrapper) return;

    if (document.fullscreenElement) {
      if (document.exitFullscreen) document.exitFullscreen();
      return;
    }

    if (wrapper.classList.contains('video-pseudo-fullscreen')) {
      wrapper.classList.remove('video-pseudo-fullscreen');
      document.body.style.overflow = '';
      const closeBtn = document.getElementById('pseudoFsCloseBtn');
      if (closeBtn) closeBtn.remove();
      return;
    }

    let handled = false;
    if (video) {
      if (typeof video.webkitEnterFullscreen === 'function') {
        try {
          video.webkitEnterFullscreen();
          handled = true;
        } catch (e) {}
      }
    }

    if (!handled) {
      const req = wrapper.requestFullscreen || wrapper.webkitRequestFullscreen || wrapper.mozRequestFullScreen || wrapper.msRequestFullscreen;
      if (req) {
        try {
          req.call(wrapper);
          handled = true;
        } catch (e) {}
      }
    }

    if (!handled) {
      wrapper.classList.add('video-pseudo-fullscreen');
      document.body.style.overflow = 'hidden';
      if (!document.getElementById('pseudoFsCloseBtn')) {
        const btn = document.createElement('button');
        btn.id = 'pseudoFsCloseBtn';
        btn.type = 'button';
        btn.className = 'video-pseudo-fullscreen-close';
        btn.innerHTML = '✕ Свернуть';
        btn.onclick = () => toggleInlineVideoFullscreen(wrapperId, videoId);
        wrapper.appendChild(btn);
      }
    }
  }
  window.toggleInlineVideoFullscreen = toggleInlineVideoFullscreen;

  let broadcastCountdownTimer = null;

  function getDayLiveUrl(dayNumber) {
    try {
      const raw = localStorage.getItem('meta_marathon_settings');
      if (raw) {
        const s = JSON.parse(raw);
        const dayKey = `day${dayNumber}`;
        if (s[`${dayKey}_zoom`] && s[`${dayKey}_zoom`].trim()) return s[`${dayKey}_zoom`].trim();
        if (s[`${dayKey}_url`] && s[`${dayKey}_url`].trim()) return s[`${dayKey}_url`].trim();
      }
    } catch (e) {}
    return '';
  }

  // Модальная заглушка прямого эфира с обратным отсчетом
  function openLiveBroadcast(dayNumber = 1) {
    triggerHaptic('impact');
    const dayKey = parseInt(dayNumber, 10) || 1;
    const defaultSchedule = {
      1: { title: 'День 1: Стихии и здоровье', date: 'Материалы и видео', targetIso: '' },
      2: { title: 'День 2: Ось 1-7 домов', date: 'Материалы и видео', targetIso: '' },
      3: { title: 'День 3: Ось 2-8 домов', date: 'Материалы и видео', targetIso: '' },
      4: { title: 'День 4: Синтез всей системы', date: 'Материалы и видео', targetIso: '' }
    };
    const info = MARATHON_DAYS_INFO[dayKey] || defaultSchedule[dayKey] || defaultSchedule[1];
    const liveUrl = getDayLiveUrl(dayKey);
    const channelUrl = getChannelUrl();

    // Если админом задана реальная рабочая ссылка на Zoom/эфир (не пустая и не тестовая), открываем её:
    const isCustomLiveUrl = Boolean(liveUrl && liveUrl !== 'https://zoom.us' && !liveUrl.includes('zoom.us/test'));
    if (isCustomLiveUrl) {
      if (window.Telegram?.WebApp && typeof window.Telegram.WebApp.openLink === 'function') {
        window.Telegram.WebApp.openLink(liveUrl);
      } else {
        window.open(liveUrl, '_blank');
      }
      return;
    }

    // Иначе открываем модальную заглушку ожидания прямого эфира
    let modal = document.getElementById('metaLiveWaitModalBackdrop');
    if (!modal) {
      const html = `
        <div class="meta-wait-modal-backdrop" id="metaLiveWaitModalBackdrop">
          <div class="meta-wait-modal-card" role="dialog" aria-modal="true">
            <button type="button" class="meta-onboard-close" onclick="MetaOnboarding.closeLiveBroadcastWait()" aria-label="Закрыть">✕</button>
            <div id="metaLiveWaitModalContent"></div>
          </div>
        </div>
      `;
      document.body.insertAdjacentHTML('beforeend', html);
      modal = document.getElementById('metaLiveWaitModalBackdrop');
      modal.addEventListener('click', (e) => {
        if (e.target === modal) closeLiveBroadcastWait();
      });
    }

    const contentEl = document.getElementById('metaLiveWaitModalContent');
    const isAdmin = Boolean(localStorage.getItem('meta_admin_token'));

    contentEl.innerHTML = `
      <div class="meta-wait-icon-circle">
        <span>⏳</span>
      </div>
      <div class="meta-wait-badge">✨ Прямой эфир по расписанию</div>
      <h2 class="meta-wait-title">${escapeHTML(info.title)}</h2>
      <p class="meta-wait-sub">Старт трансляции: <strong>${escapeHTML(info.date)}</strong></p>

      <div class="meta-countdown-grid" id="metaLiveCountdownGrid">
        <div class="meta-countdown-box">
          <span class="meta-countdown-num" id="cdDays">00</span>
          <span class="meta-countdown-label">Дней</span>
        </div>
        <div class="meta-countdown-box">
          <span class="meta-countdown-num" id="cdHours">00</span>
          <span class="meta-countdown-label">Часов</span>
        </div>
        <div class="meta-countdown-box">
          <span class="meta-countdown-num" id="cdMins">00</span>
          <span class="meta-countdown-label">Минут</span>
        </div>
        <div class="meta-countdown-box">
          <span class="meta-countdown-num" id="cdSecs">00</span>
          <span class="meta-countdown-label">Секунд</span>
        </div>
      </div>

      <div class="meta-wait-info-card">
        <div class="meta-wait-info-text">
          🚪 <strong>Материалы и видеоурок</strong> открываются в личном кабинете по расписанию вашего прохождения интенсива.
        </div>
        <div class="meta-wait-info-text" style="margin-top: 8px;">
          📱 Напоминания и ссылки на дополнительные разборы приходят прямо в <strong>Telegram-бот и канал</strong>.
        </div>
      </div>

      <div class="meta-wait-actions" style="display: flex; flex-direction: column; gap: 8px;">
        ${channelUrl ? `
        <a href="${channelUrl}" target="_blank" rel="noopener noreferrer" class="btn-tg-channel" style="display: flex; align-items: center; justify-content: center; gap: 8px; width: 100%; height: 46px; background: #1A8754 !important; border: none !important; border-radius: 12px !important; color: #FFFFFF !important; font-size: 13.5px !important; font-weight: 700 !important; text-decoration: none !important; box-sizing: border-box !important;">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0;"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
          <span>📢 Перейти в Telegram-канал</span>
        </a>` : ''}
        <button type="button" class="meta-btn-secondary" onclick="MetaOnboarding.closeLiveBroadcastWait()">
          <span>Хорошо, жду открытия</span>
        </button>
      </div>

      ${isAdmin ? `
        <div style="margin-top: 12px; border-top: 1px dashed rgba(20, 18, 20, 0.1); padding-top: 8px;">
          <button type="button" onclick="MetaOnboarding.setLiveUrlForDay(${dayKey})" style="background: none; border: none; font-size: 11px; color: #8C6A2E; cursor: pointer; text-decoration: underline;">
            ⚙️ Задать ссылку на эфир/Zoom (Администратор)
          </button>
        </div>
      ` : ''}
    `;

    const secLeft = (typeof getDripSecondsLeft === 'function') ? getDripSecondsLeft(dayKey) : 0;
    const targetIso = (secLeft > 0) ? new Date(Date.now() + secLeft * 1000).toISOString() : new Date().toISOString();
    startLiveCountdown(info.targetIso || targetIso);
    modal.classList.add('is-open');
    onModalStateChanged();
  }

  function startLiveCountdown(targetIso) {
    if (broadcastCountdownTimer) clearInterval(broadcastCountdownTimer);

    function update() {
      const target = new Date(targetIso).getTime();
      const now = Date.now();
      const diff = Math.max(0, target - now);

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const mins = Math.floor((diff / 1000 / 60) % 60);
      const secs = Math.floor((diff / 1000) % 60);

      const dEl = document.getElementById('cdDays');
      const hEl = document.getElementById('cdHours');
      const mEl = document.getElementById('cdMins');
      const sEl = document.getElementById('cdSecs');

      if (dEl) dEl.textContent = String(days).padStart(2, '0');
      if (hEl) hEl.textContent = String(hours).padStart(2, '0');
      if (mEl) mEl.textContent = String(mins).padStart(2, '0');
      if (sEl) sEl.textContent = String(secs).padStart(2, '0');
    }

    update();
    broadcastCountdownTimer = setInterval(update, 1000);
  }

  function closeLiveBroadcastWait() {
    triggerHaptic('light');
    if (broadcastCountdownTimer) {
      clearInterval(broadcastCountdownTimer);
      broadcastCountdownTimer = null;
    }
    const modal = document.getElementById('metaLiveWaitModalBackdrop');
    if (modal) {
      modal.classList.remove('is-open');
    }
    onModalStateChanged();
  }

  function setLiveUrlForDay(dayNumber) {
    const current = getDayLiveUrl(dayNumber);
    const newUrl = prompt(`Вставьте ссылку на прямой эфир Дня ${dayNumber} (Zoom / Pruffme / YouTube / Rutube):`, current);
    if (newUrl !== null) {
      const cleanUrl = newUrl.trim();
      let settings = {};
      try {
        const raw = localStorage.getItem('meta_marathon_settings');
        if (raw) settings = JSON.parse(raw);
      } catch (e) {}
      settings[`day${dayNumber}_zoom`] = cleanUrl;
      localStorage.setItem('meta_marathon_settings', JSON.stringify(settings));
      closeLiveBroadcastWait();
      alert(`Ссылка на эфир Дня ${dayNumber} сохранена!`);
    }
  }

  function lockDayCard(card, dayNumber) {
    if (!card) return;
    card.classList.remove('unlocked');
    const badge = card.querySelector('.badge-locked, .badge-available, .badge-paid');
    if (badge) {
      badge.className = 'badge-locked';
      badge.textContent = '🔒 Закрыто';
    }
    const footer = card.querySelector('.day-card-footer');
    if (footer) {
      const hoursMap = { 2: '24 часа', 3: '48 часов', 4: '72 часа' };
      footer.innerHTML = `
        <span class="day-time-tag">⏳ Откроется через ${hoursMap[dayNumber] || '24 часа'}</span>
      `;
    }
  }

  function unlockDayCard(card, dayNumber) {
    if (!card) return;
    card.classList.add('unlocked');
    const badge = card.querySelector('.badge-locked, .badge-available, .badge-paid') || document.getElementById(`day${dayNumber}StatusBadge`);
    if (badge) {
      badge.className = 'badge-available';
      badge.textContent = '✓ Доступно';
    }
    const iconSpan = card.querySelector('.day-date-title span:first-child');
    if (iconSpan && iconSpan.textContent.includes('🔒')) {
      iconSpan.textContent = dayNumber === 4 ? '🔥' : '🟢';
    }
    const footer = card.querySelector('.day-card-footer');
    if (footer) {
      const videoUrl = getVideoUrlForDay(dayNumber);
      const liveUrl = getDayLiveUrl(dayNumber);
      const hasLiveBroadcast = Boolean(liveUrl && liveUrl !== 'https://zoom.us' && !liveUrl.includes('zoom.us/test'));

      if (hasLiveBroadcast) {
        footer.innerHTML = `
          <span class="day-time-tag">🔴 Прямой эфир</span>
          <a href="/day-${dayNumber}.html" class="day-action-link" style="color: #1A8754; font-weight: 800;">
            <span>Смотреть прямой эфир →</span>
          </a>
        `;
      } else if (videoUrl) {
        footer.innerHTML = `
          <span class="day-time-tag">🎬 Урок доступен</span>
          <a href="/day-${dayNumber}.html" class="day-action-link" style="color: #1A8754; font-weight: 700;">
            <span>Смотреть урок →</span>
          </a>
        `;
      } else {
        footer.innerHTML = `
          <span class="day-time-tag">Материалы и видео</span>
          <a href="/day-${dayNumber}.html" class="day-action-link">
            <span>Перейти к уроку →</span>
          </a>
        `;
      }
    }
  }

  // Универсальное и безопасное открытие ссылок оплаты внутри Telegram и VK (без потери сессии и away.vk.ru)
  function openExternalPaymentUrl(url, dayNum) {
    triggerHaptic('impact');
    try {
      localStorage.setItem('meta_pending_payment_day', String(dayNum || 'all'));
      localStorage.setItem('meta_payment_started_at', Date.now().toString());
    } catch (e) {}

    // Telegram: нативное открытие без закрытия WebApp
    if (window.Telegram?.WebApp && typeof window.Telegram.WebApp.openLink === 'function') {
      window.Telegram.WebApp.openLink(url);
      return;
    }

    // Обычный браузер (Mac/Windows)
    window.open(url, '_blank');
  }

  // Универсальное открытие внешних ссылок (Telegram канал, поддержка и др.)
  function openExternalLink(url) {
    if (!url) return;
    if (window.Telegram?.WebApp) {
      if (url.includes('t.me/') && typeof window.Telegram.WebApp.openTelegramLink === 'function') {
        window.Telegram.WebApp.openTelegramLink(url);
        return;
      }
      if (typeof window.Telegram.WebApp.openLink === 'function') {
        window.Telegram.WebApp.openLink(url);
        return;
      }
    }
    window.open(url, '_blank');
  }
  window.openMetaExternalLink = openExternalLink;

  // Прямой переход к покупке всех 4 дней (GetCourse) без промежуточных модалок